import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";
import { Notificar } from "../../Comunes/Notificador";
import SeleccionarPersonaModal from "../../Comunes/PersonaUnificada/SeleccionarPersonaModal";

function OperacionesCambioCodeudor({
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEditar = false,
  permiteEliminar = false,
  soloLectura = false,
}) {
  const tableRef = useRef();

  useEffect(() => {
    const botonesTabla = permiteSeleccionar ? ["selectAll", "selectNone"] : [];
    const posicionDom = permiteSeleccionar
      ? '<"mb-3"B><"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>'
      : '<"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>';

    function renderEliminar(data, type, row) {
      return row.tipoAccion === "E"
        ? '<small class="font-italic text-danger">[Excluir]</small>'
        : data;
    }

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      paging: !permiteEditar,
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "multi",
        selector: "td:first-child",
      },
      dom: posicionDom,
      buttons: botonesTabla,
      columns: [
        {
          title: "Selecionar",
          data: null,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo",
          data: "fechaPeriodo",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Tipo Persona Codeudor Reportado",
          data: "identificacionCodeudorReportado.tipoPersona.descripcionLarga",
        },
        {
          title: "Identificación del Codeudor Reportado",
          data: "identificacionCodeudorReportado.codigo",
        },
        {
          title: "Nombre del Codeudor Reportado",
          data: "nombreCodeudorReportado",
        },
        {
          title: "Tipo Persona Codeudor Propuesto",
          data: "identificacionCodeudorPropuesto.tipoPersona.descripcionLarga",
          render: renderEliminar,
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Identificación del Codeudor Propuesto",
          data: "identificacionCodeudorPropuesto.codigo",
          render: renderEliminar,
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Nombre del Codeudor Propuesto",
          data: "nombreCodeudorPropuesto",
          render: renderEliminar,
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Tipo de Acción",
          data: null,
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            function actualizarOperacionesCodeudor(codeudorPropuesto) {
              const indices = tabla
                .rows(function (index, data) {
                  return (
                    data.identificacionCodeudorReportado.codigo ===
                      cellData.identificacionCodeudorReportado.codigo &&
                    data.identificacionCodeudorReportado.tipoPersona.codigo ===
                      cellData.identificacionCodeudorReportado.tipoPersona
                        .codigo
                  );
                })
                .indexes();

              indices.each(function (index) {
                const row = tabla.row(index);
                const rowData = row.data();

                rowData.tipoAccion = "M";
                rowData.identificacionCodeudorPropuesto =
                  codeudorPropuesto.identificacionPrincipal;
                rowData.nombreCodeudorPropuesto =
                  codeudorPropuesto.nombreCompleto;

                row.data(rowData).draw();
              });

              actualizarOperaciones(tabla.rows().data().toArray());
            }

            const botonModificar = (
              <button
                className="btn btn-outline-primary btn-xs"
                title="Modificar Codeudor"
              >
                <i className="fas fa-edit"></i>
              </button>
            );

            ReactDOM.render(
              <div>
                {permiteEditar ? (
                  <div className="row mb-2">
                    <div>
                      <SeleccionarPersonaModal
                        boton={botonModificar}
                        actualizarPersona={actualizarOperacionesCodeudor}
                      />

                      <button
                        className="btn btn-outline-danger btn-xs js-eliminar-codeudor ml-2"
                        title="Excluir Codeudor"
                      >
                        <i className="fas fa-times-circle"></i>
                      </button>
                    </div>
                  </div>
                ) : null}

                <div className="row">
                  {rowData.tipoAccion === "M" ? (
                    <h6>
                      <span className="badge badge-primary">Modificar</span>
                    </h6>
                  ) : rowData.tipoAccion === "E" ? (
                    <h6>
                      <span className="badge badge-danger">Excluir</span>
                    </h6>
                  ) : rowData.tipoAccion === null ? (
                    <h6>
                      <small className="text-muted">Sin asignar</small>
                    </h6>
                  ) : null}
                </div>
              </div>,
              cell
            );
          },
          searchable: false,
          orderable: false,
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Excluir de Solicitud",
          data: null,
          defaultContent:
            "<button class='btn btn-danger btn-sm js-eliminar'><i class='fa fa-trash'></i></button>",
          searchable: false,
          orderable: false,
          visible: permiteEliminar,
        },
      ],
      columnDefs: [
        {
          targets: 0,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", ".js-eliminar", function () {
      if (tabla.rows().data().count() === 1) {
        Notificar(
          "error",
          "No se puede eliminar. La solicitud debe tener al menos una operación."
        );
        return;
      }

      tabla.row($(this).parents("tr")).remove().draw();
      actualizarOperaciones(tabla.rows().data().toArray());
    });

    tabla.on("click", ".js-eliminar-codeudor", function () {
      const tr = $(this).closest("tr");
      const datosFilaActual = tabla.row(tr).data();

      const indices = tabla
        .rows(function (index, data) {
          return (
            data.identificacionCodeudorReportado.codigo ===
              datosFilaActual.identificacionCodeudorReportado.codigo &&
            data.identificacionCodeudorReportado.tipoPersona.codigo ===
              datosFilaActual.identificacionCodeudorReportado.tipoPersona.codigo
          );
        })
        .indexes();

      indices.each(function (index) {
        const row = tabla.row(index);
        const rowData = row.data();

        rowData.tipoAccion = "E";
        rowData.identificacionCodeudorPropuesto = null;
        rowData.nombreCodeudorPropuesto = null;

        row.data(rowData).draw();
      });

      actualizarOperaciones(tabla.rows().data().toArray());
    });
  }, [
    operaciones,
    actualizarOperaciones,
    permiteSeleccionar,
    permiteEditar,
    permiteEliminar,
    soloLectura,
  ]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesCambioCodeudor;
